import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getEnvLevel } from '@/selectors/originSelectors';
import { getBdaasAirportsUrl } from '@/selectors/bdaasSelectors';
import { useRouteParams } from '@/context/routeParamsContext';
import { useBdaasAirports } from './airportHooks/airportsFetchyeHooks';

export const useDevCorsWarning = () => {
  const { error: bdaasAirportsError } = useBdaasAirports();
  const { product } = useRouteParams();
  const url = useSelector(getBdaasAirportsUrl(product));

  const envLevel = useSelector(getEnvLevel);

  useEffect(() => {
    if (bdaasAirportsError && envLevel === 'E0') {
      window.alert(
        `Failed to load data while running on localhost. It may be that your CORS policy is blocking the request to ${url} from localhost. This is a known issue in the E0 environment. To work around this please run your browser with the --disable-web-security flag or use a CORS blocking extension. See this page for more details https://medium.com/@beligh.hamdi/run-chrome-browser-without-cors-872747142c61.`
      );
    }
  }, [bdaasAirportsError, envLevel, url]);
};
